<template>
  <div
    id="app"
    @keyup.esc="closeWarning"
    :class="{'tw-pointer-events-none': stepInTransition}"
  >
    <div class="topLine" />
    <div class="container">
      <header class="header">
        <router-link
          class="logo"
          to="/"
        >
          <img
            alt="Vue logo"
            class="logo__img"
            src="./assets/img/logo/logo.png"
          >
        </router-link>
        <div class="contact">
          <p class="contact__text tw-font-helvetica">
            Contact Starline Security Today!
          </p>
          <a
            class="contact__phone tw-text-4xl tw-tracking-wider"
            href="tel:+07 3272 2974"
          >07 3272 2974</a>
        </div>
      </header>
    </div>

    <nav
      class="menu"
      :class="'menu_double' "
    >
      <div class="container">
        <div
          class="menu__trigger menu__link"
          @click="menuShow = !menuShow"
          @keyup.esc="menuShow = !menuShow"
        >
          menu
        </div>
        <transition name="fade">
          <ul
            class="menu__list"
            :class="{menu__list_active: menuShow}"
          >
            <li
              v-for="link in menuItems.routs"
              :key="link.text"
              class="menu__item"
              @click="menuShow = false"
            >
              <router-link
                class="menu__link"
                :to="link.url"
              >
                {{ link.text }}
              </router-link>
            </li>

            <li
              v-for="link in menuItems.links"
              :key="link.text"
              class="menu__item"
              @click="menuShow = false"
            >
              <a
                :href="link.url"
                target="_blank"
                class="menu__link"
              >{{ link.text }}</a>
            </li>
          </ul>
        </transition>
      </div>
    </nav>

    <router-view />

    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <p class="footer__copyright">
              &#xA9;Starline Security 2019. All rights reserved.
            </p>
          </div>
          <div class="col-sm-6">
            <router-link
              :to="{name: 'infoPage'}"
              class="footer__copyright"
              target="_blank"
            >
              Terms & Conditions
            </router-link>
          </div>
        </div>
      </div>
    </footer>

    <transition name="slide">
      <preloader v-if="preloader" />
    </transition>

    <generic-question tabindex="0"/>
    <errors-modal tabindex="0" />
  </div>
</template>

<script>

import Preloader from './components/Preloader'
import errorsModal from './components/modals/errorModal'
import genericQuestion from './components/modals/GenericQuestion'

export default {

    components: {
        Preloader,
        errorsModal,
        genericQuestion
    },
    data() {
        return {
            menuShow: false,
            menu: null,
        }
    },

    computed: {
        login() {
            return request.hasToken()
        },
        stepInTransition() {
          return this.$store.state['demoWizard'].stepInTransition
        },

        menuItems() {
            let menu = this.$store.getters['menu/menu']
            let menusObj = {
                routs: [],
                links: [],
            }
            _.forEach(menu, item => {
                if(item.link){
                    menusObj.links.push(item)
                }
                else{
                    menusObj.routs.push(item)
                }
            })
            return menusObj
        },

        preloader() {
            return this.$store.getters['preloader/preloader']
        }
    },

    created() {
        this.getMenu()
    },

    mounted() {
        document.body.addEventListener('keyup', e => {
            if (e.keyCode === 27){
                this.$store.commit('errorsModal/closeModal')
                // this.$store.commit('createdOrder/warningModal', false);
                // this.$store.commit('createdOrder/deleteModal', false);
                // this.$store.commit('createdOrder/warningOutOfSquare', false);
                this.$store.commit('deleteModalGlobal/setStatus', false)
                this.$store.commit('deleteModalGlobal/setParams', {
                    itemType: String,
                    action: String,
                    actionAfter: {},
                    actionData: {}
                })
                this.$store.commit('orderPreview/delete', false)
                this.$store.commit('orderPreview/cancel', false)
                this.$store.commit('orderPreview/cloneWindow', false)
                this.$store.commit('orderPreview/setTotalPriceWindow', false)
                this.$store.commit('orderPreview/setSettingsWindow', false)
                this.$store.commit('filterOrders/setOpenModal', false)
                this.$store.commit('packages/setClone', false)
            }
        })
        return this.$store.dispatch('state/state')
    },

    methods: {
        getMenu() {
            return this.$store.dispatch('menu/menu')
        },

        isAdmin(){
            return localStorage.getItem('user_role') === 'admin'

        },

        closeWarning(){
            this.$store.commit('errorsModal/closeModal')
        }
    },
}

</script>

<style lang="scss">
  @import "assets/scss/main";

  #app {
    font-family: $helvetica;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .topLine {
    display: block;
    height: 20px;
    width: 100%;
    background-color: $navy;
  }

</style>
